import OuterSwiper from '~/javascripts/components/User/ProfileMap/OuterSwiper';
import ViewMap from '~/javascripts/components/User/ProfileMap/ViewMap';
import cx from 'classnames';
import store from '~/javascripts/store.js';
import { observer } from 'mobx-react';
import { useLayoutEffect } from 'react';

const MapContainer = observer((props) => {
  useLayoutEffect(() => {
    setCompletedProjectsMapState();
    fetchProjects();
    getProjectSummaryText();
  }, []);

  const fetchProjects = () => {
    $.getJSON(`/api/v1/projects/search?user_id=${props.userId}`, (response) => {
      if (response) {
        store.projectDetailsMap.projectsList = new Map(
          Object.entries(response.projects)
        );
        store.projectDetailsMap.bounds = response.bounds;
      }
    });
  };

  const getProjectSummaryText = () => {
    $.getJSON(
      `/api/v1/projects/user_project_summary?user_id=${props.userId}`,
      (response) => {
        if (response) {
          store.projectDetailsMap.userProjectSummaryText = response.body;
        }
      }
    );
  };

  const setCompletedProjectsMapState = () => {
    store.projectDetailsMap.userId = props.userId;
    store.projectDetailsMap.userName = props.userName;
    store.projectDetailsMap.peopleServedSponsoredProjects =
      props.peopleServedSponsoredProjects;
    store.projectDetailsMap.peopleServedSpringProjects =
      props.peopleServedSpringProjects;
    store.projectDetailsMap.peopleServedD2pProjects =
      props.peopleServedD2pProjects;
    store.projectDetailsMap.pichaPhotosUrl = props.pichaPhotosUrl;
    store.projectDetailsMap.countryBackgroundImageUrls =
      props.countryBackgroundImageUrls;
  };

  const displayImpactMap = () =>
    !props.suppressLifetimeImpactForVip &&
    store.projectDetailsMap.projectsList.size > 0;

  return (
    <>
      {displayImpactMap() && (
        <div
          className='-mx-2 pt-1 pb-4 px-2 border-solid border-t border-0 border-grey-40 pt-3 overflow-x-hidden impact-wrapper bg-cw-white'
          id='impact'
        >
          <div className='row'>
            <div
              className='h40 font-heading text-left'
              dangerouslySetInnerHTML={{
                __html: `${props.userName}&rsquo;s reported impact to date`,
              }}
            />
            <div className='impact-summary-and-map'>
              <p
                className='p40 text-left mt-1 mb-3 mx-auto'
                dangerouslySetInnerHTML={{
                  __html: store.projectDetailsMap.userProjectSummaryText,
                }}
              />
              <div className='impact-wrapper relative rounded-sm overflow-hidden'>
                <div
                  className={cx('toggle-btn', {
                    invert: store.projectDetailsMap.displayMap,
                  })}
                  onClick={() =>
                    (store.projectDetailsMap.displayMap =
                      !store.projectDetailsMap.displayMap)
                  }
                />
                <OuterSwiper />
                {store.projectDetailsMap.outerSwiperInitialized && (
                  <ViewMap accessToken={props.accessToken} />
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
});

export default MapContainer;
